import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

export const TitleText = styled(Text)({
    textTransform: "uppercase",
});

export const QRCard = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing.xxSmall,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.medium,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const QRHeader = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    border: `1px solid ${theme.colors[theme.colorMode].text_inverse_disabled}`,
    borderTopLeftRadius: theme.cornerRadius.medium,
    borderTopRightRadius: theme.cornerRadius.medium,
    padding: theme.spacing.small,
    background: `linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, ${theme.colors[theme.colorMode].background_Primary} 100%), ${theme.colors[theme.colorMode].background_Secondary};`,
}));

export const QRImageWrapper = styled.div(({ theme }) => ({
    borderRadius: theme.cornerRadius.small,
    overflow: "hidden",
    lineHeight: 0,
}));

export const WhatsAppShareButton = styled(SuperButton)(({ theme }) => ({
    width: "100%",
    borderRadius: theme.cornerRadius.small,
    marginBottom: theme.spacing.medium,
}));
